export function format(str : string, ...values : any) {
  return str.replace(/{(\d+)}/g, function(match: any, index: string | number) {
    return typeof values[index] !== 'undefined' ? values[index] : match;
  });
}

export function randstr(prefix : string)
{
    return Math.random().toString(36).replace('0.',prefix || '');
}